export default __webpack_public_path__ + "static/avatar-special-engin-0-45f92f6d370c3dd643ee6530aed0428d.png";